/**
 * Helper para exibição de mensagens do sistema
 * 
 * Este helper contém as mensagens padrão do sistema em português brasileiro.
 * As mensagens são organizadas por categoria para facilitar a manutenção.
 */

// Mensagens do sistema em PT-BR
const messages = {
  // ===== GENÉRICAS =====
  ERROR_LOAD: 'Erro ao carregar dados',
  ERROR_CREATE: 'Erro ao criar registro',
  ERROR_UPDATE: 'Erro ao atualizar registro',
  ERROR_DELETE: 'Erro ao deletar registro',
  ERROR_GENERIC: 'Ocorreu um erro inesperado',
  ERROR_REQUIRED_FIELD: 'Campo obrigatório',
  ERROR_INVALID_EMAIL: 'E-mail inválido',
  
  SUCCESS_CREATE: 'Registro criado com sucesso',
  SUCCESS_UPDATE: 'Registro atualizado com sucesso',
  SUCCESS_DELETE: 'Registro deletado com sucesso',
  SUCCESS_ACTIVATE: 'Registro ativado com sucesso',
  SUCCESS_INACTIVATE: 'Registro inativado com sucesso',

  // ===== CONFIRMAÇÕES =====
  CONFIRM_DELETE: 'Confirmar exclusão?',
  CONFIRM_ACTIVATE: 'Confirmar ativação?',
  CONFIRM_INACTIVATE: 'Confirmar inativação?',
  CONFIRM_CHANGE_STATUS: 'Confirmar mudança de status?',
  YES: 'Sim',
  NO: 'Não',
  CANCEL: 'Cancelar',
  CONFIRM: 'Confirmar',

  // ===== VALIDAÇÃO DE FORMULÁRIOS =====
  REQUIRED_FIELD: 'Campo obrigatório',
  INVALID_EMAIL: 'E-mail inválido',
  INVALID_CPF: 'CPF inválido',
  INVALID_CNPJ: 'CNPJ inválido',
  INVALID_PHONE: 'Telefone inválido',
  INVALID_CEP: 'CEP inválido',
  INVALID_DATE: 'Data inválida',
  INVALID_TIME: 'Hora inválida',
  PASSWORD_MISMATCH: 'As senhas não coincidem',
  PASSWORD_MIN_LENGTH: 'A senha deve ter no mínimo 6 caracteres',

  // ===== USUÁRIOS =====
  USER: 'Usuário',
  USERS: 'Usuários',
  USER_NOT_FOUND: 'Usuário não encontrado',
  NEW_USER: 'Novo Usuário',
  EDIT_USER: 'Editar Usuário',
  USER_TYPE: 'Tipo de Usuário',
  MY_PROFILE: 'Meu Perfil',
  CHANGE_PASSWORD: 'Alterar Senha',
  ERROR_EMAIL_EXISTS: 'E-mail já cadastrado',
  ERROR_CPF_EXISTS: 'CPF já cadastrado',
  ERROR_PASSWORD_INVALID: 'Senha incorreta',
  ERROR_FORGOT_PASSWORD: 'Erro ao solicitar nova senha',
  ERROR_RESET_PASSWORD: 'Erro ao redefinir senha',

  // ===== CLIENTES =====
  CLIENT: 'Cliente',
  CLIENTS: 'Clientes',
  CLIENT_NOT_FOUND: 'Cliente não encontrado',
  NEW_CLIENT: 'Novo Cliente',
  EDIT_CLIENT: 'Editar Cliente',

  // ===== LOTES/BATCHES =====
  BATCH: 'Lote',
  BATCHES: 'Lotes',
  BATCH_NOT_FOUND: 'Lote não encontrado',
  NEW_BATCH: 'Novo Lote',
  EDIT_BATCH: 'Editar Lote',
  CREATED_BY: 'Criado Por',

  // ===== LOGIN/AUTENTICAÇÃO =====
  LOGIN: 'Entrar',
  LOGIN_ERROR: 'Erro ao fazer login',
  LOGIN_INVALID_CREDENTIALS: 'Usuário ou senha inválidos',
  SESSION_EXPIRED: 'Sessão expirada. Faça login novamente.',
  LOGOUT: 'Sair',
  LOGOUT_SUCCESS: 'Logout realizado com sucesso',
  WELCOME: 'Bem-vindo',

  // ===== AÇÕES =====
  ACTIONS: 'Ações',
  SAVE: 'Salvar',
  EDIT: 'Editar',
  DELETE: 'Excluir',
  BACK: 'Voltar',
  SEARCH: 'Buscar',
  FILTER: 'Filtrar',
  CLEAR: 'Limpar',
  CLEAR_FILTERS: 'Limpar Filtros',
  NEW: 'Novo',
  VIEW: 'Visualizar',
  ACTIVATE: 'Ativar',
  INACTIVATE: 'Inativar',
  CHANGE_STATUS: 'Alterar Status',
  SUBMIT: 'Enviar',
  ADD: 'Adicionar',
  REMOVE: 'Remover',
  CLOSE: 'Fechar',

  // ===== STATUS =====
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  STATUS: 'Status',

  // ===== CAMPOS DE FORMULÁRIO =====
  NAME: 'Nome',
  EMAIL: 'E-mail',
  PASSWORD: 'Senha',
  NEW_PASSWORD: 'Nova Senha',
  CURRENT_PASSWORD: 'Senha Atual',
  CONFIRM_PASSWORD: 'Confirmar Senha',
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  PHONE: 'Telefone',
  CEP: 'CEP',
  ZIP_CODE: 'CEP',
  ADDRESS: 'Endereço',
  NUMBER: 'Número',
  COMPLEMENT: 'Complemento',
  NEIGHBORHOOD: 'Bairro',
  CITY: 'Cidade',
  STATE: 'Estado',
  DATE: 'Data',
  TIME: 'Hora',
  DESCRIPTION: 'Descrição',
  OBSERVATION: 'Observação',

  // ===== CAMPOS ESPECÍFICOS =====
  FIRST_NAME: 'Nome',
  LAST_NAME: 'Sobrenome',
  COMPANY_NAME: 'Razão Social',
  COMPANY_DOCUMENT: 'CNPJ',
  NICKNAME: 'Apelido/Nome Fantasia',
  SEGMENT: 'Segmento',
  INVOICE_NUMBER: 'Nota Fiscal',
  DRUM_QUANTITY: 'Qtd. Tambores',
  ATTACHMENT: 'Anexo',

  // ===== FILTROS =====
  FILTER_BY_NAME: 'Filtrar por nome',
  FILTER_BY_EMAIL: 'Filtrar por e-mail',
  FILTER_BY_STATUS: 'Filtrar por status',
  FILTER_BY_DATE: 'Filtrar por data',
  FILTER_BY_CLIENT: 'Filtrar por cliente',
  START_DATE: 'Data Inicial',
  END_DATE: 'Data Final',

  // ===== PAGINAÇÃO =====
  TOTAL_RECORDS: 'Total de registros',
  SHOWING: 'Mostrando',
  OF: 'de',
  RECORDS: 'registros',
  NO_DATA: 'Nenhum registro encontrado',

  // ===== LOADING =====
  LOADING: 'Carregando...',
  PROCESSING: 'Processando...',
  PLEASE_WAIT: 'Por favor, aguarde...',

  // ===== UPLOAD =====
  UPLOAD_FILE: 'Enviar arquivo',
  UPLOAD_SUCCESS: 'Arquivo enviado com sucesso',
  UPLOAD_ERROR: 'Erro ao enviar arquivo',
  FILE_TOO_LARGE: 'Arquivo muito grande',
  INVALID_FILE_TYPE: 'Tipo de arquivo inválido',
  SELECT_FILE: 'Selecionar arquivo',
  DROP_FILE_HERE: 'Arraste o arquivo aqui',
};

/**
 * Retorna uma mensagem pelo código
 * @param {string} code - Código da mensagem
 * @param {string} defaultMessage - Mensagem padrão caso não encontre o código
 * @returns {string} A mensagem correspondente
 */
export const displayMessage = (code, defaultMessage = 'Mensagem não encontrada') => {
  return messages[code] || defaultMessage;
};

/**
 * Retorna uma mensagem formatada com parâmetros
 * @param {string} code - Código da mensagem
 * @param {array} params - Array com os parâmetros a serem substituídos
 * @returns {string} A mensagem formatada
 * 
 * Exemplo:
 * displayMessageWithParams('ERROR_NOT_FOUND', ['Cliente'])
 * Retorna: 'Cliente não encontrado'
 */
export const displayMessageWithParams = (code, params = []) => {
  let message = messages[code] || code;
  
  params.forEach((param, index) => {
    message = message.replace(`{${index}}`, param);
  });
  
  return message;
};

/**
 * Retorna todas as mensagens
 * @returns {object} Objeto com todas as mensagens
 */
export const getAllMessages = () => {
  return messages;
};

export default messages;

